export const travel_classes = {
  Y: "Economy",
  D: "Premium",
}

export function get_travel_classes(key) {
  if (travel_classes[key] !== undefined) return travel_classes[key]
  return key
}